export default "Open the Google Colab notebook and walk through the hands-on exercises with the students.\n\nLink: https://tinyurl.com/img-manipulation\n"